// index.js (Exemplo)
import React from "react";
import ReactDOM from "react-dom/client";

// 1) CSS do Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// 2) JS do Bootstrap (contém Popper + funcionalidades, incluindo collapse/accordion)
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "./index.css"; // Seus estilos globais
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
